import React, {Dispatch, SetStateAction} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'

type Props = {
  placeholder: string
  searchTerm: string
  setSearchTerm: Dispatch<SetStateAction<string>>
}

const SearchBox = ({placeholder, searchTerm, setSearchTerm}: Props) => {
  return (
    <div className='d-flex align-items-center position-relative my-1'>
      <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
      <input
        type='text'
        data-kt-user-table-filter='Search Group'
        className='form-control form-control-solid w-250px ps-14'
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  )
}

export default SearchBox
